import { useCallback, useEffect, useState } from "react";
import { useToast } from "./Toast";
import {
  fetchActivity,
  fetchApplications,
  formatDateTime,
  registerApplication,
} from "../../services/adminService";

export default function SubmissionActivity() {
  const [apps, setApps] = useState([]);
  const [activity, setActivity] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [busyId, setBusyId] = useState(null);
  const toast = useToast();

  const load = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const [a, log] = await Promise.all([fetchApplications(), fetchActivity()]);
      setApps(a);
      setActivity(log);
    } catch (err) {
      console.error(err);
      setError("Could not load activity.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const register = async (app) => {
    setBusyId(app.id);
    try {
      await registerApplication(app);
      await load();
      toast.show(`${app.fullName} added to the register`);
    } catch (err) {
      console.error(err);
      toast.show("Could not add this applicant to the register", "error");
    } finally {
      setBusyId(null);
    }
  };

  return (
    <>
      <header className="na-page-head">
        <div>
          <h1>Submission activity</h1>
          <p className="na-muted">Membership applications from the website, and recent changes made by admins.</p>
        </div>
        <div className="na-head-actions">
          <button className="na-btn" onClick={load}>Refresh</button>
        </div>
      </header>

      {error && <p className="na-error">{error}</p>}

      <section className="na-card na-table-card">
        <h2 className="na-section-title">Website applications</h2>
        <div className="na-table-wrap">
          <table className="na-table">
            <thead>
              <tr><th>Applicant</th><th>Category</th><th>Organization</th><th>Submitted</th><th>Register</th></tr>
            </thead>
            <tbody>
              {loading && <tr><td colSpan="5" className="na-empty">Loading…</td></tr>}
              {!loading && apps.length === 0 && <tr><td colSpan="5" className="na-empty">No applications yet.</td></tr>}
              {!loading &&
                apps.map((a) => (
                  <tr key={a.id}>
                    <td>
                      <strong>{a.fullName}</strong>
                      <small className="na-block">{a.email}</small>
                    </td>
                    <td>{a.category || "—"}</td>
                    <td>{a.organization || "—"}</td>
                    <td>{formatDateTime(a.createdAt)}</td>
                    <td>
                      {a.registered ? (
                        <span className="na-badge na-badge-paid">On register</span>
                      ) : (
                        <button className="na-btn na-btn-sm" disabled={busyId === a.id} onClick={() => register(a)}>
                          {busyId === a.id ? "Adding…" : "Add to register"}
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </section>

      <section className="na-card na-table-card">
        <h2 className="na-section-title">Admin activity</h2>
        <ul className="na-log">
          {!loading && activity.length === 0 && <li className="na-empty">No activity recorded yet.</li>}
          {activity.map((l) => (
            <li key={l.id}>
              <span>{l.message}</span>
              <small>{l.actor} · {formatDateTime(l.createdAt)}</small>
            </li>
          ))}
        </ul>
      </section>
    </>
  );
}
